import pageNotFound from 'Components/pages/notfound/pageNotFound';

export default [
  {
    path: '*',
    name: 'NotFound',
    component: pageNotFound,
  },
];
